import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { Field, useFormikContext } from 'formik';
import React, { memo } from 'react';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { CustomerTypes, ECustomerSearchTypes, initialFilterValues } from 'v2/interfaces/rating';

import type { IFilter } from 'v2/interfaces/rating';

const Fields = memo(() => {
  const loading = false;
  const { resetForm, dirty, isSubmitting, isValid, values, setFieldValue } = useFormikContext<IFilter>();

  function onResetForm() {
    resetForm({ values: initialFilterValues });
  }

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setFieldValue('customer', '');
    setFieldValue('customer_type', v);
  };

  return (
    <Grid container spacing={2} direction='row' alignItems='flex-start' justify='space-between'>
      <Grid item md={2} xs={12}>
        <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
      </Grid>

      <Grid item md={4} xs={12}>
        <Grid container>
          <Grid item xs={4}>
            <Field
              id='customer_type'
              name='customer_type'
              label='Cliente'
              fullWidth
              options={CustomerTypes}
              component={SelectFormField}
              onChange={onChangeCustomerType}
            />
          </Grid>
          <Grid item xs={8}>
            <Field
              id='customer'
              name='customer'
              component={TextFormField}
              fullWidth
              label={values.customer_type === ECustomerSearchTypes.NAME ? 'Nome' : 'E-mail'}
              placeholder={values.customer_type === ECustomerSearchTypes.NAME ? 'Insira o nome' : 'Insira o e-mail'}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} xs={12}>
        <Field id='product_id' name='product_id' fullWidth hasLabel component={SelectProduct} />
      </Grid>

      <Grid item xs={6} md={1} style={{ marginTop: 24 }}>
        <Button id='clean-filter-button' disabled={!dirty || isSubmitting || loading} onClick={() => onResetForm()} fullWidth>
          limpar
        </Button>
      </Grid>
      <Grid item xs={6} md={1} style={{ marginTop: 24 }}>
        <Button
          id='filter-button'
          fullWidth
          disabled={isSubmitting || loading || !isValid}
          startIcon={<Icon>filter_list</Icon>}
          type='submit'
          variant='contained'
          color='secondary'
        >
          filtrar
        </Button>
      </Grid>
    </Grid>
  );
});

export default Fields;
